import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import type {
  CreatedRiskWorkspace,
  NewRiskWorkspace,
  RiskWorkspace,
} from '@app/types/workspaceTypes'

export const fetchRiskWorkspaces = async (_clientName: string): Promise<RiskWorkspace[]> => {
  const { data } = await apiClient.get<RiskWorkspace[]>(Endpoint.riskWorkspaces)
  return data
}

export const fetchRiskWorkspaceById = async (id: string): Promise<RiskWorkspace> => {
  const { data } = await apiClient.get<RiskWorkspace>(`${Endpoint.riskWorkspaces}/${id}`)
  return data
}

export const postRiskWorkspace = async (
  newWorkspace: NewRiskWorkspace,
): Promise<CreatedRiskWorkspace> => {
  const { data } = await apiClient.post<CreatedRiskWorkspace>(Endpoint.riskWorkspaces, newWorkspace)
  return data
}

export const deleteRiskWorkspace = async (id: string): Promise<void> => {
  await apiClient.delete(`${Endpoint.riskWorkspaces}/${id}`)
}

export const updateRiskWorkspace = async (
  id: string,
  updatedWorkspace: NewRiskWorkspace,
): Promise<void> => {
  await apiClient.put(`${Endpoint.riskWorkspaces}/${id}`, updatedWorkspace)
}
